import React, { useState } from 'react';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, MailIcon, PhoneIcon, Trash2Icon } from 'lucide-react';
import { Button, LinkButton, buttonClasses } from '../../components/ui/Button';
import { TextField } from '../../components/ui/Field';
import { StatusBadge } from '../../components/admin/StatusBadge';
import { QuoteStatusBadge } from '../../components/admin/QuoteStatusBadge';
import { useAdminData } from '../../contexts/AdminDataContext';
import { formatDate, telHref } from '../../utils/format';
import { effectiveStatus, formatKr } from '../../utils/quote';
export function CustomerDetail() {
  const {
    customerId
  } = useParams();
  const navigate = useNavigate();
  const {
    customers,
    casesForCustomer,
    quotesForCustomer,
    updateCustomer,
    deleteCustomer
  } = useAdminData();
  const customer = customers.find(entry => entry.id === customerId);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(customer);
  if (!customer) return <Navigate to="/admin/kunder" replace data-id="element-616" data-mp="2v5hs9wx804qk" />;
  const list = [...casesForCustomer(customer.id)].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  const quotes = [...quotesForCustomer(customer.id)].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  return <div className="px-5 py-7 md:px-8 md:py-10" data-id="element-617" data-mp="305dv3su6lq4j">
      <Link to="/admin/kunder" className="inline-flex items-center gap-2 text-sm text-ink-muted transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-618" data-mp="303t2w9vcaj9u">
        <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-619" data-mp="27it7n3gtty69" />
        Kunder
      </Link>

      <div className="mt-4 flex flex-wrap items-start justify-between gap-4" data-id="element-620" data-mp="2m6wcuan1p5u0">
        <h1 className="font-display text-[clamp(1.8rem,5vw,2.5rem)] font-bold leading-[1.05] tracking-tight text-ink" data-id="element-621" data-mp="2hf4jxtgf2o0p">
          {customer.name}
        </h1>
        <button type="button" onClick={() => {
        if (window.confirm(`Slet ${customer.name}? Kundens sager slettes også. Handlingen kan ikke fortrydes.`)) {
          deleteCustomer(customer.id);
          navigate('/admin/kunder');
        }
      }} className="inline-flex h-9 items-center gap-2 rounded-full border border-line px-3.5 text-sm text-ink-soft transition-colors duration-200 ease-smooth hover:border-ink/30 hover:text-ink" data-id="element-622" data-mp="1tnh0txpech8z">
          <Trash2Icon className="h-4 w-4" aria-hidden="true" data-id="element-623" data-mp="35vfgslzawa0o" />
          Slet kunde
        </button>
      </div>

      <div className="mt-6 grid gap-5 lg:grid-cols-[0.7fr_1.3fr]" data-id="element-624" data-mp="3ath1tcgaejes">
        <section className="rounded-card border border-line bg-white p-6" data-id="element-625" data-mp="3euizvpygwpf6">
          <div className="flex items-center justify-between gap-3" data-id="element-626" data-mp="3jtndqtwc7bbu">
            <h2 className="text-xs font-semibold uppercase tracking-wider text-ink-muted" data-id="element-627" data-mp="3jrspp6prr33j">
              Kundeoplysninger
            </h2>
            {!editing && <button type="button" onClick={() => {
            setDraft(customer);
            setEditing(true);
          }} className="text-sm font-medium text-accent hover:text-accent-deep" data-id="element-628" data-mp="z2d1mjhxpshl">
                Rediger
              </button>}
          </div>

          {editing && draft ? <form className="mt-4 space-y-4" onSubmit={event => {
          event.preventDefault();
          updateCustomer(customer.id, draft);
          setEditing(false);
        }} data-id="element-629" data-mp="vf56xe0tct6j">
              <TextField id="kd-navn" label="Navn" required value={draft.name} onChange={event => setDraft({
            ...draft,
            name: event.target.value
          })} data-id="element-630" data-mp="lkd7s5rl1y9n" />
              <TextField id="kd-tlf" label="Telefon" type="tel" value={draft.phone} onChange={event => setDraft({
            ...draft,
            phone: event.target.value
          })} data-id="element-631" data-mp="2avx8ypoajk7i" />
              <TextField id="kd-mail" label="E-mail" type="email" value={draft.email} onChange={event => setDraft({
            ...draft,
            email: event.target.value
          })} data-id="element-632" data-mp="2dwqoqyw02inb" />
              <TextField id="kd-adresse" label="Adresse" value={draft.address} onChange={event => setDraft({
            ...draft,
            address: event.target.value
          })} data-id="element-633" data-mp="28yf9u9qulhy8" />
              <TextField id="kd-noter" label="Noter" value={draft.notes} onChange={event => setDraft({
            ...draft,
            notes: event.target.value
          })} data-id="element-634" data-mp="200v9d30t7poo" />
              <div className="flex gap-3 pt-1" data-id="element-635" data-mp="1c97trh90011p">
                <Button type="submit" size="sm" data-id="element-636" data-mp="1caiwddqpj2r8">
                  Gem
                </Button>
                <Button type="button" variant="secondary" size="sm" onClick={() => setEditing(false)} data-id="element-637" data-mp="1h6zjc4m67b2q">
                  Annuller
                </Button>
              </div>
            </form> : <>
              <dl className="mt-4 space-y-3 text-[15px]" data-id="element-638" data-mp="spin1165uf2m">
                <div data-id="element-639" data-mp="16o8ikcdc06ov">
                  <dt className="text-ink-muted" data-id="element-640" data-mp="16oqnryhz1v8x">Navn</dt>
                  <dd className="mt-0.5 text-ink" data-id="element-641" data-mp="12l2f1chlstm3">{customer.name}</dd>
                </div>
                <div data-id="element-642" data-mp="1gl3huxhfib47">
                  <dt className="text-ink-muted" data-id="element-643" data-mp="1gkbjjewg5za8">Telefon</dt>
                  <dd className="mt-0.5 text-ink" data-id="element-644" data-mp="1bma2t0mhuc1x">{customer.phone || '—'}</dd>
                </div>
                <div data-id="element-645" data-mp="1qb6i9iqvqrck">
                  <dt className="text-ink-muted" data-id="element-646" data-mp="1qbob05ec2nfq">E-mail</dt>
                  <dd className="mt-0.5 break-all text-ink" data-id="element-647" data-mp="1qd9a88bleujx">{customer.email || '—'}</dd>
                </div>
                <div data-id="element-648" data-mp="1lefv6bgnqvhn">
                  <dt className="text-ink-muted" data-id="element-649" data-mp="1zbbecwqmi3bf">Adresse</dt>
                  <dd className="mt-0.5 text-ink" data-id="element-650" data-mp="1z9rznakm80br">{customer.address || '—'}</dd>
                </div>
                <div data-id="element-651" data-mp="1uaottnwt9q2q">
                  <dt className="text-ink-muted" data-id="element-652" data-mp="rzlso107bqht">Noter</dt>
                  <dd className="mt-0.5 text-ink" data-id="element-653" data-mp="s16nlrqfhbg7">{customer.notes || 'Ingen noter.'}</dd>
                </div>
              </dl>
              <div className="mt-6 flex flex-col gap-2 sm:flex-row" data-id="element-654" data-mp="ww2jj2ysciyl">
                <LinkButton href={telHref(customer.phone)} variant="secondary" size="sm" data-id="element-655" data-mp="10yqqf53xvfsx">
                  <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-656" data-mp="15sbg89vdp3h1" />
                  Ring
                </LinkButton>
                <LinkButton href={`mailto:${customer.email}`} variant="secondary" size="sm" data-id="element-657" data-mp="1arxr4cnqi7mo">
                  <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-658" data-mp="1fn3g5kcfo2ez" />
                  Send e-mail
                </LinkButton>
              </div>
            </>}
        </section>

        <div className="space-y-5" data-id="element-659" data-mp="1op2xkdrd18ig">
        <section className="rounded-card border border-line bg-white" data-id="element-660" data-mp="3mfdyk8ogug67">
          <header className="border-b border-line px-5 py-4" data-id="element-661" data-mp="3mh78bwudlgif">
            <h2 className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-662" data-mp="3qi0twjkcij85">Tilbud</h2>
          </header>
          <ul className="divide-y divide-line" data-id="element-663" data-mp="3iy8bjz4636h7">
            {quotes.map(quote => <li key={quote.id} className="flex flex-wrap items-center justify-between gap-3 px-5 py-4" data-id="element-664" data-mp="3e5oxz25hcbce">
                <div className="min-w-0" data-id="element-665" data-mp="398gemy8li19k">
                  <p className="text-[15px] text-ink" data-id="element-666" data-mp="395an7cchunao">
                    <span className="font-medium" data-id="element-667" data-mp="357cysbqjs58c">{quote.quoteNumber}</span> – {quote.title}
                  </p>
                  <p className="mt-0.5 text-sm text-ink-muted" data-id="element-668" data-mp="5qer7gqnahya">
                    {formatDate(quote.quoteDate)} · {formatKr(quote.total)}
                  </p>
                </div>
                <div className="flex items-center gap-3" data-id="element-669" data-mp="3subdp4z0r545">
                  <QuoteStatusBadge status={effectiveStatus(quote)} data-id="element-670" data-mp="3nwtdq42zc08a" />
                  <Link to={`/admin/tilbud/${quote.id}`} className={buttonClasses('secondary', 'sm')} data-id="element-671" data-mp="3nynowqog8dz6">
                    Åbn
                  </Link>
                </div>
              </li>)}
            {quotes.length === 0 && <li className="px-5 py-10 text-center text-sm text-ink-muted" data-id="element-672" data-mp="gdq5tzid3vn0">
                Ingen tilbud på denne kunde endnu.
              </li>}
          </ul>
        </section>

        <section className="rounded-card border border-line bg-white" data-id="element-673" data-mp="6glkg1wcc479">
          <header className="border-b border-line px-5 py-4" data-id="element-674" data-mp="6ieu7q2934jh">
            <h2 className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-675" data-mp="bfy8ur2v1jby">Sager</h2>
          </header>
          <ul className="divide-y divide-line" data-id="element-676" data-mp="z5j2c3wn3yzh">
            {list.map(item => <li key={item.id} className="flex flex-wrap items-center justify-between gap-3 px-5 py-4" data-id="element-677" data-mp="142iynn3otnde">
                <div className="min-w-0" data-id="element-678" data-mp="peend46yse4n">
                  <p className="text-[15px] text-ink" data-id="element-679" data-mp="ue0ztbeyxqce">
                    <span className="font-medium" data-id="element-680" data-mp="ucg7lsg4mjhp">Sag #{item.number}</span> – {item.title}
                  </p>
                  <p className="mt-0.5 text-sm text-ink-muted" data-id="element-681" data-mp="1i2aii4gvxxzb">{formatDate(item.plannedDate)}</p>
                </div>
                <div className="flex items-center gap-3" data-id="element-682" data-mp="1mw5092cxk2vr">
                  <StatusBadge status={item.status} data-id="element-683" data-mp="37jfrvk2ogev5" />
                  <Link to={`/admin/sager/${item.id}`} className={buttonClasses('secondary', 'sm')} data-id="element-684" data-mp="32lw3hrc9mlph">
                    Åbn
                  </Link>
                </div>
              </li>)}
            {list.length === 0 && <li className="px-5 py-10 text-center text-sm text-ink-muted" data-id="element-685" data-mp="3ccqrb055ttd1">
                Ingen sager på denne kunde endnu.
              </li>}
          </ul>
          {list.length > 0 && <div className="border-t border-line px-5 py-4" data-id="element-686" data-mp="2jocrceuigmyu">
              <p className="text-sm text-ink-muted" data-id="element-687" data-mp="2xn2otvl8sonq">
                {list.length} {list.length === 1 ? 'sag' : 'sager'} i alt på denne kunde.
              </p>
            </div>}
        </section>
        </div>
      </div>
    </div>;
}